import { Paper, Select, styled } from "@mui/material";

export const StyledComponents = styled(Paper)(({ theme }) => ({
	padding: 20,
	height: 'min-content',
	rowGap: 24,
	display: 'grid',
	width: '100%',
	[theme.breakpoints.up('md')]: {
		minWidth: 600,
		width: 'auto'
	}
}))

export const StyledWrapper = styled('div')({ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0px 16px' })

export const StyledLogoWrapper = styled('div')({
	margin: 'auto'
})

export const StyledSelect = styled(Select)`
	& .MuiSelect-select:focus {
		background-color: inherit;
	}
	& .MuiSelect-icon {
		fill: inherit;
	}
`;

export const FlagContainer = styled('div')`
	width: 16px;
	margin-right: 8px;
`;

export const FlagSelectContainer = styled('div')`
	margin-top: 3px;
	width: 20px;
`;
